import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import GeoView from 'views/customers/geo'; // Importing GeoView component
import MoneyView from 'views/customers/money'; // Importing MoneyView component
import AgeView from 'views/customers/age'; // Importing AgeView component
import TagsView from 'views/customers/tags'; // Importing TagsView component
import PositionsView from 'views/customers/positions'; // Importing PositionsView component

/**
 * StatisticsView class extends JetView to create a custom view for statistics.
 */
export default class StatisticsView extends JetView {
    /**
     * Configures the layout of the StatisticsView.
     * @returns {Object} The configuration object for the view layout.
     */
    config() {
        return {
            rows: [
                {
                    height: 10, // Spacer row with a height of 10
                },
                {
                    type: 'wide', // Main container of the view
                    rows: [
                        {
                            gravity: 2, // Allocates more space to this row
                            type: 'wide',
                            cols: [
                                GeoView, // First column containing GeoView
                                {
                                    type: 'wide',
                                    minWidth: 370, // Minimum width for the second column
                                    rows: [PositionsView, TagsView], // Nested rows with PositionsView and TagsView
                                },
                            ],
                        },
                        {
                            type: 'wide',
                            cols: [MoneyView, AgeView], // Second row with MoneyView and AgeView
                        },
                    ],
                },
            ],
        };
    }
}

// FILE DOCUMENTED
